export default __webpack_public_path__ + "static/media/loading.829fbb53.gif";